import { render, staticRenderFns } from "./tableList2.vue?vue&type=template&id=200aaffb&scoped=true"
import script from "./tableList2.vue?vue&type=script&lang=js"
export * from "./tableList2.vue?vue&type=script&lang=js"
import style0 from "./tableList2.vue?vue&type=style&index=0&id=200aaffb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200aaffb",
  null
  
)

export default component.exports